export default "/images/ai_docs.svg?79a91c0a2296d4701106be7eed72d839";